export default __webpack_public_path__ + "static/media/baseline-repeat-24px.9d9d4ad4.svg";